export { default as translations } from './translations.json';

export const INTERVALS = ['weekly', 'biweekly', 'monthly'];

/**
 * Get subscription box config from listing.
 * @param {Object|null} listing
 * @returns {Object|null}
 */
export const getBoxConfig = (listing) => {
  const config = listing?.attributes?.publicData?.subscriptionBox;
  return config?.enabled ? config : null;
};

/**
 * Calculate next ship date from interval.
 * @param {'weekly'|'biweekly'|'monthly'} interval
 * @param {Date} [from]
 * @returns {Date}
 */
export const getNextShipDate = (interval, from = new Date()) => {
  const date = new Date(from);
  if (interval === 'weekly') date.setDate(date.getDate() + 7);
  else if (interval === 'biweekly') date.setDate(date.getDate() + 14);
  else if (interval === 'monthly') date.setMonth(date.getMonth() + 1);
  return date;
};
